import { useEffect, useState } from "react";

import { Form } from "@/components/ui/form";
import {
  TObituaryRemoteTribute,
  TObituaryTributeItem,
  TObituaryTributesItem,
  TObituaryTributesList,
} from "@/types/obituary";
import { zodResolver } from "@hookform/resolvers/zod";
import { Loader2, X } from "lucide-react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import CImage from "../CImage";
import CustomInput from "../generator/fields/CustomInput";
import { Button } from "../ui/button";
import UserText from "./UserText";
const FormSchema = z.object({
  tributeType: z.any(),
  name: z
    .string({ required_error: "Ihr Name ist erforderlich" })
    .min(1, { message: "Ihr Name ist erforderlich" })
    .min(2, { message: "Die Eingabe hat zu wenig Zeichen" }),
});
type TributeProps = {
  info: TObituaryTributesItem;
  value: number;
};
type Inputs = z.infer<typeof FormSchema>;

type Props = {
  slug: string;
  closeModal: () => void;
  loadTributesList: () => void;
  activeModal: string | null;
  setActiveModal: (value: string | null) => void;
  tributesList: TObituaryRemoteTribute;
  tributeList: TObituaryTributeItem[] | undefined;
  setTributeList: (list: TObituaryTributeItem[] | undefined) => void;
};

const AddTributeModal = ({
  closeModal,
  activeModal,
  setActiveModal,
  tributesList,
  tributeList,
  setTributeList,
  loadTributesList,
  slug,
}: Props) => {
  const form = useForm<Inputs>({
    resolver: zodResolver(FormSchema),
    mode: "onSubmit",
    defaultValues: {
      tributeType: activeModal,
      name: "",
    },
  });

  function onSubmit(values: z.infer<typeof FormSchema>) {
    sendValuesToApi(values);
  }
  const sendValuesToApi = async (values: z.infer<typeof FormSchema>) => {
    setIsSending(true);
    const formData = new FormData();
    formData.append("slug", slug);
    formData.append("name", values.name);
    formData.append("tributeType", values.tributeType);
    // formData.append("job_id", "9");
    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_DOMAIN_ROUTE}/api/obituary/tribute/`,
        {
          method: "POST",
          body: formData,
        }
      );
      let resp = await response.json();
    } catch (e) {}
    setIsSending(false);
    closeModal();
    loadTributesList();
  };

  useEffect(() => {
    tributeHandler(activeModal!);
  }, []);

  const tributeHandler = (name: string) => {
    if (tributeList!) setActiveModal(name);
    if (name === "DOVE") {
      setValue("tributeType", "DOVE");
      setTributeList(tributesList.DOVE ? tributesList.DOVE : []);
    } else if (name === "STAR") {
      setValue("tributeType", "STAR");
      setTributeList(tributesList.STAR ? tributesList.STAR : []);
    } else if (name === "FLOWER") {
      setValue("tributeType", "FLOWER");
      setTributeList(tributesList.FLOWER ? tributesList.FLOWER : []);
    } else if (name === "CANDLE") {
      setValue("tributeType", "CANDLE");
      setTributeList(tributesList.CANDLE ? tributesList.CANDLE : []);
    }
  };

  const { register, setValue, watch } = form;

  const [isSending, setIsSending] = useState(false);

  const GetModalTribute = ({ info, value }: TributeProps) => {
    return (
      <div
        className={`relative cursor-pointer ${
          activeModal === info.name
            ? "opacity-100 grayscale-0"
            : "opacity-80 grayscale"
        }`}
        onClick={() => {
          tributeHandler(info.name);
        }}
      >
        <CImage
          src={info.icon}
          width={90}
          height={90}
          alt=""
          className={`relative ${
            activeModal === info.name
              ? "h-12 w-12 lg:h-16 lg:w-16"
              : "h-10 w-10 lg:h-12 lg:w-12"
          }`}
        />
        <div className="absolute -right-1 -top-1 flex h-8 w-8 items-center justify-center rounded-3xl bg-primary font-bold text-white">
          {value}
        </div>
      </div>
    );
  };

  const GetList = () => {
    if (activeModal === null) {
      return <p>Wählen Sie einen Tribut</p>;
    } else {
      if (tributeList === undefined || tributeList.length === 0) {
        return <p>Als Erstes schreibe ich einen Tribut</p>;
      } else {
        return (
          <>
            {tributeList.map((item) => (
              <UserText as="p" value={item.name} />
            ))}
          </>
        );
      }
    }
  };

  let nameRegister = register("name");
  let name = watch("name");

  return (
    <div className="fixed -top-10 left-0 z-50 flex h-screen w-screen items-center justify-center bg-secondary-800/80 p-4 pb-0 backdrop-blur-md lg:p-8">
      <div className="z-10 flex w-full flex-col gap-4 rounded-md bg-white shadow-lg lg:w-[400px]">
        <div className="flex w-full flex-row p-4 pb-2">
          <h4 className="flex flex-grow text-secondary">Tribute</h4>
          <p></p>
          <button
            className="text-secondary"
            onClick={() => {
              closeModal();
            }}
          >
            <X className="h-8 w-8" />
          </button>
        </div>
        <div className="flex h-12 w-auto flex-row items-center justify-center gap-8 px-4 py-2 lg:h-16">
          <GetModalTribute
            info={TObituaryTributesList.filter((i) => i.name === "FLOWER")[0]}
            value={tributesList.FLOWER ? tributesList.FLOWER.length : 0}
          />
          <GetModalTribute
            info={TObituaryTributesList.filter((i) => i.name === "CANDLE")[0]}
            value={tributesList.CANDLE ? tributesList.CANDLE.length : 0}
          />
          <GetModalTribute
            info={TObituaryTributesList.filter((i) => i.name === "DOVE")[0]}
            value={tributesList.DOVE ? tributesList.DOVE.length : 0}
          />
          <GetModalTribute
            info={TObituaryTributesList.filter((i) => i.name === "STAR")[0]}
            value={tributesList.STAR ? tributesList.STAR.length : 0}
          />
        </div>
        <div className="flex h-[120px] flex-col overflow-y-auto text-sm text-secondary ">
          <GetList />
        </div>
        <div className="min-h-28 w-full rounded-b-md bg-primary p-4">
          <p className="text-caption-1 text-left font-semibold uppercase  tracking-widest subpixel-antialiased">
            Wählen Sie Ihren Tribut
          </p>
          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(onSubmit)}
              className="mx-auto flex w-full flex-row items-start justify-center gap-2 text-left"
            >
              <input className="hidden" {...register("tributeType")} />
              <div className="flex w-full flex-col gap-2">
                <CustomInput
                  name="name"
                  form={form}
                  label=""
                  placeholder="Ihr Name"
                  textError="text-white/60"
                />
              </div>
              <Button
                type="submit"
                id="add-tribute"
                disabled={isSending}
                className={`btn large primary solid-white mt-[4px] h-12 !text-primary`}
              >
                {isSending ? <Loader2 className="h-4 w-4 animate-spin" /> : "Senden"}
                
              </Button>
            </form>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default AddTributeModal;
